export default ({ serializer }) => (state, { payload: location }) => {
  const { search } = location;
  const urlSearchParams = new URLSearchParams(search);

  return serializer.parse(urlSearchParams);
};
